import type { ThemeConfig } from 'antd';

const theme: ThemeConfig = {
  token: {
    colorPrimary: '#8a71d6',
    colorBgContainer: 'var(--background-color)',
    colorText: 'var(--text-primary)',
    colorBgElevated: 'var(--background-color)',
  },
  components: {
    Timeline: {
      tailColor: 'var(--primary-color-faded)',
    },
    Button: {
      colorPrimary: '#8a71d6',
      colorTextDisabled: 'var(--text-disabled)',
    },
    Card: {
      actionsBg: 'var(--background-color)',
    },
    Radio: {
      colorPrimary: 'var(--secondary-color)',
      colorBgContainer: '#fff',
    },
    Checkbox: {
      colorBgContainer: '#fff',
    },
    Table: {
      colorBgContainer: 'transparent',
      colorText: 'var(--text-primary)',
    },
    Spin: {
      colorPrimary: 'var(--secondary-color)',
    },
    Slider: {
      handleColor: 'var(--secondary-color)',
      dotActiveBorderColor: 'var(--secondary-color)',
      dotBorderColor: 'var(--secondary-color)',
      trackBg: 'var(--secondary-color)',
      trackHoverBg: 'var(--secondary-color)',
      // handleActiveOutlineColor: 'var(--secondary-color)', // TODO: increase antd version
    },
  },
};

export default theme;
